// removed by extract-text-webpack-plugin
module.exports = {"columnsWrapper":"_3Dd3XrfrwiP_0bnK5xxvdK","column":"_1I4V4D5S39HwfOOSza3u_u","mobileColumn":"Gy7YWIMJo94ZUw5Ht-Ywo","keyValuePair":"_2-k8nJLWKcjCWIkziVrJVF","keyCont":"_2-vx8bZxmJmhQRrc8p5oh0","valCont":"ZRJ0b-4tuusQzHeg1ETrV","value":"_1hbuIbIRPB_Ro-rtE3W907"};


//////////////////
// WEBPACK FOOTER
// ./elements/ClientTwoColumns.scss
// module id = 1179
// module chunks = 0